import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import { type CourseState } from '@editor2/types/courseState';
import { getReorderConflictIndex } from '@editor2/services/conflictResolutionService';
import { ChangesStatus } from '@editor2/types/changesStatus';
import { filterByEntityId } from '../common/conflictResolutionHelper';

export class ChapterModifiedDeletedConflictResolver {
	acceptCurrent = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId } = conflict;
		const filteredInitial = filterByEntityId(state.initialCourse.chapters.ids, entityId);

		state.initialCourse.chapters.ids = filteredInitial;
		state.changes.chapters[entityId] = [ChangesStatus.New];

		// update chapter reorder conflict if exists
		const reorderConflictIndex = getReorderConflictIndex(state, state.book.family_id);
		if (reorderConflictIndex > -1) {
			state.conflicts[reorderConflictIndex].initial = filteredInitial;
		}
	};

	acceptIncoming = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId } = conflict;
		const filteredInitial = filterByEntityId(state.initialCourse.chapters.ids, entityId);
		const filteredCurrent = filterByEntityId(state.chapters.ids, entityId);

		state.initialCourse.chapters.ids = filteredInitial;
		state.chapters.ids = filteredCurrent;
		state.changes.chapters[entityId] = [];

		// update chapter reorder conflict if exists
		const reorderConflictIndex = getReorderConflictIndex(state, state.book.family_id);
		if (reorderConflictIndex > -1) {
			state.conflicts[reorderConflictIndex].initial = filteredInitial;
			state.conflicts[reorderConflictIndex].current = filteredCurrent;
		}
	};

	acceptBoth = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		throw new Error('Accept both is not allowed for this type of conflict');
	};
}
